import React from "react"
import ContentLoader from "react-content-loader"

const MyLoader = (props) => (
    <ContentLoader
        speed={1.5}
        width={403}
        height={346}
        viewBox="0 0 403 346"
        backgroundOpacity={0.4}
        backgroundColor="#c1cce2"
        foregroundColor="#fff"
        {...props}
    >
        <rect x="20" y="20" rx="18" ry="18" width="315" height="35" />
        <rect x="20" y="295" rx="18" ry="18" width="120" height="24" />
        <rect x="20" y="74" rx="18" ry="18" width="380" height="203" />
    </ContentLoader>
)

export default MyLoader


